import { createApp } from 'vue'
import StreamDonationQrCode from './StreamDonationQrCode'

const el = '.kb-component--stream-donation-qr-code'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((StreamDonationQrCodeDOM) => {
            const fundraisingId = StreamDonationQrCodeDOM.dataset.fundraisingId || ''
            const variation = StreamDonationQrCodeDOM.dataset.variation || 'dark'
            const border = StreamDonationQrCodeDOM.dataset.border || ''
            const component = createApp(StreamDonationQrCode, { fundraisingId, variation, border }).use(Store)
            component.mount(StreamDonationQrCodeDOM)
        })
    }
}
